<template> 
 
    <button type="button" class="btn btn-sm border border-pmes-danger btn-light-pmes-danger" data-bs-toggle="modal" :data-bs-target="'#' + modal "  @click="gerarBoletim" >  
        <span class="mx-5"><i class="fa fa-file-pdf bi fs-2x text-danger"></i> <span>Faltas</span></span>
    </button> 
    <div class="modal fade" :id="modal" tabindex="-1" aria-hidden="true"  >  
        <div class="modal-dialog" style="max-width:1200px;">  
            <div class="modal-content"  :style="'min-height: 450px; max-height: ' + (height_w -50) + 'px;'">  
                <div class="modal-header"> 
					<h2>Pdf</h2> 
					<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" >
						<span class="svg-icon svg-icon-1">
							<inline-svg src="media/icons/duotone/Navigation/Close.svg" />
						</span>
					</div> 
				</div> 
				<div class="modal-body scroll-y " :key="identificador" >
                    <CardRh >  
                        <div class="col-12 col-md-12  min-h-1850px"> 
                            <iframe :src="url" width="100%"  :height="(height_w -250)  + 'px'"  style="border: none;"></iframe>   
                        </div>   
                    </CardRh> 
				</div>   
			</div> 
		</div> 
	</div> 
</template>

<script lang="ts">  
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import {  Prop  , Watch } from 'vue-property-decorator';   
    import FaltaService from   "@/service/v1/sigap/FaltaService"  

    
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 


    @Options({
        name: "AulaPdf",
        components: {  CardRh  },   
    }) 
    export default class AulaPdf extends Vue { 
          
        @Prop( ) readonly turmaId!: any   
        @Prop( ) readonly cpf!: any   
         

        @authStore.Getter
		public token!: any
        
        public identificador = 1 ;   
        public url: any = "";
        public service = new FaltaService();
        public modal: any = "modal_pdf_faltas_agrupadas";
        public height_w: any =  window.innerHeight;
        public height_s: any =  screen.height;

        @Watch('matricula')
		dadosAtualizado(newVal: string) { 
            this.identificador++; 
		} 
  
        public gerarBoletim(){
            this.url =   null;  
            setTimeout(() => {
                this.url = this.service.getApiUrl() + `/Relatorio/GetFaltaAgrupadas/Pdf?cpf=${this.cpf != null ? this.cpf : ''}&turmaId=${this.turmaId != null ? this.turmaId : ''}&token=${this.token}`;
                this.identificador++;
            }, 2 ); 
        }

    } 
</script> 


<style scoped>  
    .btn-flex-full{
        max-width: 100%;
        min-width: 100%;
    } 
    .start-90{
        left: 97% !important;
    }
    .btn:hover .fa-file-pdf{
        color: #ffffff !important;
    }
</style>